import React, { useCallback } from 'react';
import { IWinLossRates } from 'services/DashboardApi/types';
import { theme } from '../../../../../tailwind.config';
import { ErrorBar } from 'ui/NetworkStatusBar';
import { MetricCard, MetricCardTitle } from './MetricCardComponents';

interface IWinLossRatesCardProps {
  winLossRates: IWinLossRates;
  isErrorCrmMetrics: boolean;
}

export const WinLossRatesCard: React.FC<IWinLossRatesCardProps> = ({ winLossRates, isErrorCrmMetrics }) => {
  const totalCases = winLossRates.wins + winLossRates.losses;

  const renderTooltipContent = useCallback(
    () => (
      <p className="m-0 font-pt-sans text-[13px] text-black p-[5px]">
        Sales agent percentage of leads discarded or confirmed over total cases.
      </p>
    ),
    []
  );

  return (
    <MetricCard>
      <MetricCardTitle title="Win and Loss Rates" renderTooltipContent={renderTooltipContent} />

      {isErrorCrmMetrics ? (
        <div className="w-full flex justify-center items-center mt-[30px] mb-[30px]">
          <ErrorBar />
        </div>
      ) : (
        <>
      <div className="flex flex-col gap-[5px] items-center justify-center text-center w-full">
        <p className="m-0 font-pt-sans text-[15px] text-black">Total Cases</p>
        <p className="m-0 font-pt-sans font-bold text-[21px] text-black">{totalCases}</p>
      </div>

      <div className="flex gap-[20px] items-start w-full">
        <div className="flex flex-1 flex-col gap-[5px] items-center min-w-0">
          <p className="m-0 font-pt-sans text-[15px] text-black text-center">Win Rate</p>
          <p className="m-0 font-pt-sans text-[32px] text-center w-full" style={{ color: theme.colors['status-confirmed'] }}>
            {winLossRates.winRate.toFixed(1)} %
          </p>
          <p className="m-0 font-pt-sans text-[15px] text-black text-center">
            <span className="font-bold">{winLossRates.wins}</span> confirmed
          </p>
        </div>

        <div className="self-center shrink-0 w-px h-[89px] bg-gray-40" />

        <div className="flex flex-1 flex-col gap-[5px] items-center min-w-0">
          <p className="m-0 font-pt-sans text-[15px] text-black text-center">Loss Rate</p>
          <p className="m-0 font-pt-sans text-[32px] text-center w-full" style={{ color: theme.colors['status-cancelled'] }}>
            {winLossRates.lossRate.toFixed(1)} %
          </p>
          <p className="m-0 font-pt-sans text-[15px] text-black text-center">
            <span className="font-bold">{winLossRates.losses}</span> discarded
          </p>
        </div>
      </div>
        </>
      )}
    </MetricCard>
  );
};
